(() => {
  const initOil = (root, oil) => {
    const form = root.querySelector('[data-nb-form]');
    const id = form.querySelector('input[name="id"]');
    const quantity = form.querySelector('input[name="quantity"]');
    const buy = root.querySelector('[data-nb-submit]');
    const stickyBuy = root.querySelector('[data-nb-sticky-submit]');
    const availability = root.querySelector('[data-nb-availability]');
    const defaultUnavailable = availability?.textContent;
    const ready = root.dataset.ready === 'true';
    const initialLabel = buy.textContent;
    const currency = oil.dataset.currency || 'GBP';
    const money = new Intl.NumberFormat('en-GB', {style:'currency', currency});
    const savingMoney = new Intl.NumberFormat('en-GB', {style:'currency', currency, minimumFractionDigits:0, maximumFractionDigits:2});
    let buyable = false;
    const sync = () => {
      const withOil = oil.checked;
      const amount = Math.max(1, Math.floor(Number(quantity?.value) || 1));
      if (quantity) { quantity.value = String(amount); quantity.disabled = !ready; }
      const variantId = withOil ? oil.dataset.offerId : oil.dataset.deviceId;
      const unitPrice = Number(withOil ? oil.dataset.offerPrice : oil.dataset.devicePrice);
      const unitCompare = Number(withOil ? oil.dataset.offerCompare : oil.dataset.deviceCompare);
      const total = unitPrice * amount;
      const compareTotal = unitCompare * amount;
      const label = withOil ? oil.dataset.offerLabel : oil.dataset.deviceLabel;
      id.value = variantId;
      root.dataset.nbSelectedVariant = variantId;
      root.dataset.nbSellingTotal = String(total);
      buyable = ready && (withOil ? oil.dataset.offerAvailable : oil.dataset.deviceAvailable) === 'true';
      buy.disabled = !buyable;
      buy.textContent = !ready ? initialLabel : buyable ? stickyBuy.dataset.addLabel : withOil ? 'Currently unavailable' : stickyBuy.dataset.soldOutLabel;
      stickyBuy.disabled = buy.disabled;
      stickyBuy.textContent = buy.textContent;
      if (availability) {
        availability.hidden = buyable;
        availability.textContent = withOil ? oil.dataset.unavailableText : defaultUnavailable;
      }
      root.querySelector('[data-nb-price]').textContent = money.format(total / 100);
      root.querySelector('[data-nb-sticky-price]').textContent = money.format(total / 100);
      root.querySelector('[data-nb-shape-total]').textContent = money.format(total / 100);
      const compare = root.querySelector('.nbp-compare');
      if (compare) { compare.textContent = money.format(compareTotal / 100); compare.hidden = compareTotal <= total; }
      const saving = root.querySelector('[data-nb-shape-saving]');
      if (saving) { saving.textContent = 'Save ' + savingMoney.format((compareTotal - total) / 100); saving.hidden = compareTotal <= total; }
      root.querySelector('.nbp-sticky strong').textContent = label;
      root.querySelectorAll('[data-nb-offer-bundle-only]').forEach(element => { element.hidden = !withOil; });
      const final = root.querySelector('[data-nb-offer-final]');
      if (final) final.textContent = label + ' · ' + money.format(total / 100) + '.';
      const promo = root.querySelector('[data-nb-klarna-promo]');
      if (promo) {
        promo.dataset.sellingPrice = String(total);
        promo.hidden = promo.dataset.priceVisible !== 'true' || (['GBP','EUR'].includes(currency) && total < 5000);
      }
      root.dispatchEvent(new CustomEvent('nb:selection-total'));
    };
    oil.addEventListener('change', sync);
    quantity?.addEventListener('input', sync);
    quantity?.addEventListener('change', sync);
    form.addEventListener('submit', event => {
      sync();
      if (!buyable) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    sync();
  };
  const init = root => {
    if (root.dataset.shapeOffersReady) return;
    const oil = root.querySelector('[data-nb-shape-oil]');
    if (oil) { root.dataset.shapeOffersReady = 'true'; initOil(root, oil); return; }
    const choices = [...root.querySelectorAll('[data-nb-shape-offer]')];
    if (!choices.length) return;
    root.dataset.shapeOffersReady = 'true';
    const sync = () => {
      const selected = choices.find(choice => choice.checked);
      const bundle = selected.dataset.bundle === 'true';
      root.querySelector('[data-nb-form] input[name="id"]').value = selected.value;
      root.dataset.nbSelectedVariant = selected.value;
      const buyable = root.dataset.ready === 'true' && selected.dataset.available === 'true';
      const buy = root.querySelector('[data-nb-submit]');
      const stickyBuy = root.querySelector('[data-nb-sticky-submit]');
      buy.disabled = !buyable;
      buy.textContent = buyable ? stickyBuy.dataset.addLabel : stickyBuy.dataset.soldOutLabel;
      stickyBuy.disabled = !buyable;
      stickyBuy.textContent = buy.textContent;
      const quantity = root.querySelector('input[name="quantity"]');
      if (quantity) {
        quantity.disabled = !buyable;
        quantity.parentElement.hidden = !buyable;
      }
      const availability = root.querySelector('[data-nb-availability]');
      if (availability) availability.hidden = buyable;
      root.querySelector('[data-nb-price]').textContent = selected.dataset.price;
      root.querySelector('.nbp-compare').textContent = selected.dataset.compare;
      root.querySelector('[data-nb-sticky-price]').textContent = selected.dataset.price;
      root.dataset.nbSellingTotal = selected.dataset.priceMinor;
      root.dispatchEvent(new CustomEvent('nb:selection-total'));
      root.querySelector('.nbp-sticky strong').textContent = selected.dataset.label;
      root.querySelectorAll('[data-nb-offer-bundle-only]').forEach(element => { element.hidden = !bundle; });
      const deviceCopy = root.querySelector('[data-nb-offer-device-only]');
      if (deviceCopy) deviceCopy.hidden = bundle;
      const final = root.querySelector('[data-nb-offer-final]');
      if (final) final.textContent = selected.dataset.label + ' · ' + selected.dataset.price + '.';
      const promo = root.querySelector('[data-nb-klarna-promo]');
      if (promo) {
        promo.dataset.sellingPrice = selected.dataset.priceMinor;
        const thresholdCurrency = ['GBP','EUR'].includes(promo.dataset.currency);
        promo.hidden = promo.dataset.priceVisible !== 'true' || (thresholdCurrency && Number(selected.dataset.priceMinor) < 5000);
      }
    };
    root.querySelector('[data-nb-form]').addEventListener('submit', event => {
      const selected = choices.find(choice => choice.checked);
      if (root.dataset.ready !== 'true' || selected?.dataset.available !== 'true') event.preventDefault();
    });
    choices.forEach(choice => choice.addEventListener('change', sync));
    sync();
  };
  const scan = () => document.querySelectorAll('[data-nb-shape-mobile]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
